import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DeviceGroupDto, InfrastructureDto, ParkingSpaceDto } from '../../../../api/gen';
import { CommonModule } from '@angular/common';
import { JJamesCardComponent } from 'shared-lib';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-create-parking-space-final',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    JJamesCardComponent,
    MatIconModule,
    MatListModule
  ],
  templateUrl: './create-parking-space-final.component.html',
  styleUrl: './create-parking-space-final.component.scss'
})
export class CreateParkingSpaceFinalComponent {
  @Input({ required: true }) parkingSpace!: ParkingSpaceDto;
  @Input() infrastructure?: InfrastructureDto | null;
  @Input() deviceGroups?: DeviceGroupDto[] | null;
  @Output() finish = new EventEmitter<void>();

  onFinish() {
    this.finish.emit();
  }
}
